import React from "react";

const Report = () => {
  return null;
};

export default Report;
